import { Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';

import styled from 'shared/utils/styled';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  marginLeft: 20,
  [theme.breakpoints.down('xs')]: {
    marginLeft: 10,
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '6px 16px',
  fontSize: 15,
  fontFamily: 'NeoSansStd',
  fontWeight: 400,
  color: theme.palette.primary.main,
  textDecoration: 'none',
  whiteSpace: 'unset',
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  minHeight: 0,
  padding: 0,
}));
